/* Pezold Q4-Upgrade: Preisvorschlag-Dialog, mobile Kaufleiste, Formular-Rueckmeldungen.
   Robust: jeder Teil faengt eigene Fehler ab, damit der Shop nie bricht. */
(function () {
  'use strict';
  var d = document;
  function ready(fn) { if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', fn); else fn(); }
  function warn(m, e) { if (window.console && console.warn) console.warn('[Pezold] ' + m, e || ''); }
  var posted = /(^|[?&])contact_posted=true/.test(location.search);
  var hash = location.hash;

  function parseAmount(v) {
    var raw = String(v || '').replace(/[^0-9,\.]/g, '');
    if (raw.indexOf(',') > -1) raw = raw.replace(/\./g, '').replace(',', '.');
    return parseFloat(raw);
  }

  function initOffer() {
    var dlg = d.getElementById('PezoldOffer');
    if (!dlg) return;
    var form = dlg.querySelector('form');
    var price = parseFloat(dlg.getAttribute('data-price')) || 0;
    var lastFocus = null;

    function open() {
      lastFocus = d.activeElement;
      try { if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', ''); } catch (e) { dlg.setAttribute('open', ''); }
      d.body.classList.add('pz-dialog-open');
      var first = dlg.querySelector('[data-pz-offer-success] button') || dlg.querySelector('[data-pz-offer-amount]');
      if (first) setTimeout(function () { first.focus(); }, 80);
    }
    function close() {
      try { if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open'); } catch (e) { dlg.removeAttribute('open'); }
      d.body.classList.remove('pz-dialog-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    d.addEventListener('click', function (e) {
      if (e.target.closest('[data-pz-offer-open]')) { e.preventDefault(); open(); }
      else if (e.target.closest('[data-pz-offer-close]')) { e.preventDefault(); close(); }
    });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    dlg.addEventListener('close', function () { d.body.classList.remove('pz-dialog-open'); });

    if (form) {
      var inp = form.querySelector('[data-pz-offer-amount]');
      var err = form.querySelector('[data-pz-offer-err]');
      var btn = form.querySelector('[type="submit"]');
      function validAmount() {
        var val = parseAmount(inp && inp.value);
        var ok = val > 0 && (!price || val < price);
        if (err) err.hidden = ok;
        if (inp) inp.setCustomValidity(ok ? '' : (err ? err.textContent.trim() : 'invalid'));
        return ok ? val : 0;
      }
      if (inp) inp.addEventListener('input', function () { if (err && !err.hidden) validAmount(); else if (inp) inp.setCustomValidity(''); });
      // Pruefung beim Klick (vor Captcha- und Formular-Logik), damit nur gueltige Vorschlaege gesendet werden
      if (btn) btn.addEventListener('click', function (e) {
        var val = validAmount();
        if (!val) { e.preventDefault(); e.stopImmediatePropagation(); if (inp) inp.focus(); return; }
        if (!form.checkValidity()) return; // Browser zeigt Pflichtfelder an
        inp.value = val.toFixed(2).replace('.', ',') + ' EUR';
        inp.setCustomValidity('');
        btn.setAttribute('aria-busy', 'true');
      }, true);
    }

    // Rueckmeldung nach dem Absenden: nur dieses Formular zeigt Erfolg/Fehler
    var success = dlg.querySelector('[data-pz-offer-success]');
    if (hash === '#PezoldOfferForm' && (posted || dlg.querySelector('.errors'))) {
      open();
    } else if (success) {
      success.parentNode.removeChild(success);
    }
  }

  function initQuestionStatus() {
    var s = d.querySelector('[data-pz-q-success]');
    if (s && posted && hash !== '#PezoldObjectQuestion') s.parentNode.removeChild(s);
  }

  function initSticky() {
    var bar = d.querySelector('[data-pz-sticky]');
    var main = d.querySelector('.product__info-container .product-form__submit, product-info .product-form__submit');
    if (!bar || !main || main.disabled || !('IntersectionObserver' in window)) return;
    var btn = bar.querySelector('[data-pz-sticky-add]');
    bar.hidden = false;
    var mq = window.matchMedia('(max-width: 749px)');
    function set(on) {
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (btn) btn.tabIndex = on ? 0 : -1;
      d.body.classList.toggle('pz-sticky-on', on && mq.matches);
    }
    set(false);
    new IntersectionObserver(function (entries) {
      var en = entries[0];
      set(!en.isIntersecting && en.boundingClientRect.top < 0 && !main.disabled);
    }, { threshold: 0 }).observe(main);
    if (btn) btn.addEventListener('click', function () {
      if (main.disabled) return;
      main.click();
    });
  }

  ready(function () {
    try { initOffer(); } catch (e) { warn('Preisvorschlag', e); }
    try { initQuestionStatus(); } catch (e) { warn('Objektfrage', e); }
    try { initSticky(); } catch (e) { warn('Kaufleiste', e); }
  });
})();
